//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-239417 Remove feature flag after GA
export const getIsSocialResponseEnabled = createHasFeatureSelector(
  FeatureNames.SocialResponse,
);
